const widgets = require('./widgets');
const style = require('./style');
const $ = require('jQuery');
const { FeatureFlags } = require('../featureFlags');

/*
* {Library} pLibrary
* {(application: Application | null) => void} onApplicationUploaded
*/
function uploadApplication(pLibrary, onApplicationUploaded) {
  const _lFileInput = $('<input type="file">').css('display', 'none');

  _lFileInput.attr('accept', 'application/json');
  _lFileInput.attr('multiple', true);

  _lFileInput.click(function(pEvent) {
    pEvent.stopPropagation(); // Prevents input click to bubble up to button click which creates a loop
  });

  const lUploadedApplications = [];
  let lUploadedApplicationsCounter = 0;

  _lFileInput.change(function(pEvent) {
    // callaback only on the last successfull upload
    function onApplicationProcessed() {
      lUploadedApplicationsCounter++;
      if (lUploadedApplicationsCounter < pEvent.target.files.length) {
        // Not all files have been processed, keep going.
        return;
      }

      if (lUploadedApplications.length === 0) {
        // All files errored out
        onApplicationUploaded(null);
        return;
      }

      onApplicationUploaded(lUploadedApplications.at(-1));
    }

    Array.from(pEvent.target.files).forEach(function (pFile) {
      const _lReader = new FileReader();
      _lReader.onload = function (pEvent) {
        try {
          const _lData = JSON.parse(pEvent.target.result);
          pLibrary.uploadApplication(_lData, function (pUploadedApp, pMessage) {
            if (!pUploadedApp) {
              console.warn('Upload failed. Reason: ' + pMessage + '. Filename: ' + pFile.name);
              widgets.messageBox('Could not upload file [' + pFile.name + ']. Reason: ' + pMessage + '', 'error');
            } else {

              if (FeatureFlags.DIGITAL_CALIBRATION_FLOW && _lData.applications.find(app => app.robotParameters?.calibrationParts?.length)) {
                widgets.showConfirmCancelModal(
                  { text: 'Recalibrate Robot', style: {} },
                  { text: 'It looks like you just uploaded a new robot application. You must first recalibrate your digital calibration tool.', style: {'padding-left': '30px', 'padding-right': '30px', 'padding-top': '20px', 'padding-bottom': '1  0px'} },
                  { text: 'Recalibrate', style: {'height': '41px', 'width': '129px', 'border-color': style.cssColors.success_color, 'background-color': style.cssColors.success_color}, onClick: () => { $(".ml_tree_document:contains('Robot Assets')").last().click(), $(":contains('Digital Calibration Tools')").click();} },
                  { text: 'Do this later', style: {'height': '41px', 'width': '129px'} },
                );
              }
              lUploadedApplications.push(pUploadedApp);
            }
            onApplicationProcessed();
          });
        } catch (pError) {
          console.warn('Could not parse [' + pFile.name + ']');
          widgets.messageBox('Could not parse [' + pFile.name + ']', 'warning');
          onApplicationProcessed();
        }
      };
      _lReader.readAsText(pFile);
    });
  });

  _lFileInput.click();
}

module.exports = {
  applicationUpload: uploadApplication
};
